<template>
    <div class="relative w-full bg-gray-50 py-10 sm:py-12 md:py-16 dark:bg-surface-subtle">
        <div class="container">
            <!-- Colors follow the nav bar (HeaderNew.vue); light backgrounds get dark text for contrast -->
            <div class="grid grid-cols-1 items-stretch gap-4 sm:gap-6 md:grid-cols-2 lg:grid-cols-3">
                <!-- Mentoring Network pre svetové Slovensko Card -->
                <CategoryCard
                    class="h-full min-w-0"
                    title="Mentoring network pre svetové Slovensko"
                    description="Prihlás sa medzi stovku Slovákov a Sloveniek odhodlaných pracovať na svetovom Slovensku"
                    bg-color="bg-[#eef9f0]"
                    text-color="text-gray-900"
                    title-color="text-[#2E1943]"
                    button-class="bg-[#C68DFF] text-[#2E1943] hover:bg-[#B47DE6]"
                    link="/mentoring-network-pre-svetove-slovensko"
                    :features="[
                        'Výberový 6-mesačný program pre ľudí, ktorí chcú posúvať seba, svoje organizácie a Slovensko vpred',
                        'Záväzok aspoň 16h 1:1 mentoringu a skupinových aktivít na podporu networkingu',
                        'Možnosť spoznať top profesionálov vo vybraných segmentoch',
                    ]"
                />

                <!-- Mentoring Card -->
                <CategoryCard
                    class="h-full min-w-0"
                    title="Mentoring"
                    description="Oslov mentora/ku so skúsenosťami, ktoré ťa posunú vpred"
                    bg-color="bg-[#047274]"
                    link="/mentori"
                    :features="[
                        'Mentorstvo z rôznych odvetví',
                        'Online aj osobné stretnutia',
                    ]"
                    :example-cards="mentoringCards"
                />

                <!-- Dobrovoľníctvo Card -->
                <CategoryCard
                    class="h-full min-w-0"
                    title="Dobrobáza"
                    description="Pomáhaj a zároveň získavaj nové skúsenosti, alebo nájdi dobrovoľníkov pre svoju organizáciu"
                    bg-color="bg-[#eab308]"
                    text-color="text-gray-900"
                    button-class="bg-gray-900 text-white hover:bg-gray-800"
                    link="/dobrovolnictvo/dobrovolnicke-projekty"
                    :features="[
                        'Dobrovoľnícke príležitosti po celom Slovensku',
                        'Podľa tvojich záujmov a času',
                    ]"
                    :example-cards="volunteerCards"
                />

                <!-- Práca Card -->
                <CategoryCard
                    class="h-full min-w-0"
                    title="Práca"
                    description="Nájdi prácu, ktorá má zmysel a bude ťa napĺňať"
                    bg-color="bg-[#f97316]"
                    text-color="text-gray-900"
                    button-class="bg-gray-900 text-white hover:bg-gray-800"
                    link="/praca"
                    :features="[
                        'Práca v organizáciách, ktoré robia Slovensko ešte lepším',
                        'Aj flexi joby, aj na diaľku',
                    ]"
                    :example-cards="jobCards"
                />

                <!-- Stáže Card: same nav section as Práca, darker orange keeps the two cards apart -->
                <CategoryCard
                    class="h-full min-w-0"
                    title="Stáže"
                    description="Získaj praktické skúsenosti a rozvíjaj sa"
                    bg-color="bg-[#c2410c]"
                    link="/praca?jobTypes=staz_pre_studenta"
                    :features="[
                        'Stáže pre študentov a absolventov',
                        'Reálne projekty a zodpovednosť',
                    ]"
                    :example-cards="internshipCards"
                />

                <!-- Vzdelávanie Card -->
                <CategoryCard
                    class="h-full min-w-0"
                    title="Vzdelávanie"
                    description="Uč sa od najlepších a rozvíjaj svoje zručnosti"
                    bg-color="bg-[#c24cfc]"
                    text-color="text-gray-900"
                    button-class="bg-gray-900 text-white hover:bg-gray-800"
                    link="/vzdelavanie"
                    :features="[
                        'Podujatia, kurzy, workshopy',
                        'Študijné a štipendijné príležitosti',
                    ]"
                    :example-cards="educationCards"
                />

            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import CategoryCard from './CategoryCard.vue'

// Fetch featured items from server API
const { data: featured } = await useFetch('/api/homepage/featured-items', {
    default: () => ({
        mentors: [],
        volunteers: [],
        jobs: [],
        internships: [],
        education: []
    })
})

const mentoringCards = computed(() => featured.value?.mentors || [])
const volunteerCards = computed(() => featured.value?.volunteers || [])
const jobCards = computed(() => featured.value?.jobs || [])
const internshipCards = computed(() => featured.value?.internships || [])
const educationCards = computed(() => featured.value?.education || [])

</script>
